<template>
  <div
    @click.self="close()"
    class="fixed top-0 bottom-0 left-0 right-0 p-5 bg-black bg-opacity-80"
  >
    <div
      @click.self="close()"
      class="flex w-full h-full items-center justify-center"
    >
      <div class="w-full max-w-3xl mx-auto">
        <div class="flex w-full flex-col gap-5">
          <div class="relative">
            <button
              @click="close()"
              class="text-white text-2xl px-2.5 py-1 z-30 absolute right-0 top-0"
            >
              &#215;
            </button>
            <img
              alt="Vue logo"
              class="w-full"
              :src="viewImage.img"
            />
            <div
              class="btn-container text-white items-center justify-between flex z-30 absolute left-0 right-0 top-1/2 -translate-y-1/2 transform"
            >
              <button class="text-2xl h-8 w-8 flex items-center justify-center bg-black bg-opacity-50 rounded-full mx-1" @click="prev()">
                <span class="pb-1.5 inline-block">
                &#8249;
                </span>
              </button>
              <button class="text-2xl h-8 w-8 flex items-center justify-center bg-black bg-opacity-50 rounded-full mx-1" @click="next()">
                <span class="pb-1.5 inline-block">
                &#8250;
                </span>
                </button>
            </div>
          </div>
          <div class="">
            <div class="overflow-x-scroll buildings-carousel w-full" :ref="setBuildingsCarousel">
              <div class="flex gap-2 flex-nowrap">
                <div
                  class="flex-none w-60"
                  v-for="(building, i) in subBuildings"
                  :key="i"
                >
                  <img
                    alt="Vue logo"
                    class="w-full cursor-pointer"
                    :src="building.img"
                    @dblclick="clickImage(i)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const transactionCarousel = document.querySelector('#transaction-carousel');
// transactionCarousel.scrollLeft = 150;

// let pos = { left: 0, x: 0 };

// const mouseMoveHandler = (e) => {
//     const dx = e.clientX - pos.x;
//     transactionCarousel.scrollLeft = pos.left - dx;
// };

// const mouseUpHandler = () => {
//     document.removeEventListener('mousemove', mouseMoveHandler);
//     document.removeEventListener('mouseup', mouseUpHandler);

//     transactionCarousel.style.cursor = 'grab';
//     transactionCarousel.style.removeProperty('user-select');
// };

// const mouseDownHandler = (e) => {
//     transactionCarousel.style.cursor = 'grabbing';
//     transactionCarousel.style.userSelect = 'none';
//     pos = {
//         left: transactionCarousel.scrollLeft,
//         x: e.clientX
//     };

//     document.addEventListener('mousemove', mouseMoveHandler);
//     document.addEventListener('mouseup', mouseUpHandler);
// };

// transactionCarousel.addEventListener('mousedown', mouseDownHandler);

export default {
  props: {
    building: Object,
  },
  data() {
    return {
      viewImage: "",
      subBuildings: [],
      buildingsCarousel: "",
      viewIndex: 0,
    };
  },
  methods: {
    setBuildingsCarousel(el) {
      if (el) {
        // console.log("hahsh");
        this.buildingsCarousel = el;
        console.log(this.buildingsCarousel);
        // const transactionCarousel = document.querySelector('#transaction-carousel');
        el.scrollLeft = 150;

        let pos = { left: 0, x: 0 };

        const mouseMoveHandler = (e) => {
          const dx = e.clientX - pos.x;
          el.scrollLeft = pos.left - dx;
        };

        const mouseUpHandler = () => {
          document.removeEventListener("mousemove", mouseMoveHandler);
          document.removeEventListener("mouseup", mouseUpHandler);

          el.style.cursor = "grab";
          el.style.removeProperty("user-select");
        };

        const mouseDownHandler = (e) => {
          el.style.cursor = "grabbing";
          el.style.userSelect = "none";
          pos = {
            left: el.scrollLeft,
            x: e.clientX,
          };

          document.addEventListener("mousemove", mouseMoveHandler);
          document.addEventListener("mouseup", mouseUpHandler);
        };

        el.addEventListener("mousedown", mouseDownHandler);
      }
    },
    close() {
      this.$emit("close");
    },
    next() {
      this.viewIndex < this.subBuildings.length - 1
        ? this.viewIndex++
        : (this.viewIndex = 0);
      this.viewImage = this.subBuildings[this.viewIndex];
    },
    prev() {
      this.viewIndex > 0
        ? this.viewIndex--
        : (this.viewIndex = this.subBuildings.length - 1);
      this.viewImage = this.subBuildings[this.viewIndex];
    },
    clickImage(i) {
      this.viewIndex = i;
      this.viewImage = this.subBuildings[this.viewIndex];
    },
  },
  created() {
    // console.log(this.building);
    this.subBuildings = this.building.buildings;
    this.viewImage = this.subBuildings[this.viewIndex];
    // let buildingsCarousel = this.$refs[`buildingsCarousel`];
    // let buildingsCarousel = this.$refs[`buildingsCarousel`].classList;
    // console.log(this.buildingsCarousel);
    // console.log(this.$refs[`buildingsCarousel`]);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .buildings-carousel {
  cursor: grab;
} */
.buildings-carousel::-webkit-scrollbar {
  width: 0;
  background: transparent;
}
</style>
